var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotator20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1035",
    d: "M9.82701 0.868408L16.512 4.17644V10.4824C15.8401 10.7408 14.1343 11.8952 13.4107 13.3425C12.4597 15.2446 12.6871 16.8056 12.6871 17.4775L7.96624 19.1315L1.28125 15.5068C1.55692 14.0894 1.28125 11.1026 3.48661 7.07097C5.18242 3.97081 8.54055 1.68165 9.82701 0.868408Z",
    fill: "#95E3FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1037",
    d: "M11.5155 8.17358L16.2363 4.55542L16.7188 10.1033L14.8235 11.5161L13.1351 13.8937L12.5837 17.3741L10.275 18.1321L8.173 18.7524V17.1328L8.72434 11.9985L11.5155 8.17358Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1036",
    d: "M16.512 4.17644L9.82701 0.868408C8.54055 1.68165 5.18242 3.97081 3.48661 7.07097C1.28125 11.1026 1.35938 13.8438 1.28125 15.5068L7.96624 19.1315M16.512 4.17644C15.0647 5.29175 11.4876 7.4153 9.82701 10.4824C8.16643 13.5495 7.96624 17.0123 7.96624 19.1315M16.512 4.17644V10.4824C15.8401 10.7408 14.1343 11.8952 13.4107 13.3425C12.4597 15.2446 12.6871 16.8056 12.6871 17.4775L7.96624 19.1315",
    stroke: "#222627",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotator20);
export default __webpack_public_path__ + "static/media/rotator_20.1fd2be0e188f8c72e39eb2e3b50968eb.svg";
export { ForwardRef as ReactComponent };